import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { observer } from 'mobx-react';
import { useContext, useMemo, useState } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { Tabs } from '../../tabs';
import { ItemPickerContextInstance } from '../types/context';
import { ItemPickerGrid } from './grid';
export const ItemPickerTabs = observer(({ itemProfilePages }) => {
    const i18n = useI18n();
    const { config } = useContext(ItemPickerContextInstance);
    const tabItems = useMemo(() => getTabDataFromItemProfilePages(itemProfilePages, i18n), [itemProfilePages, i18n]);
    const [selectedTab, setSelectedTab] = useState(tabItems[0]);
    if (isEmptyArray(tabItems))
        return null;
    const selectedItemProfilePage = itemProfilePages.find(page => page.number === selectedTab.value) || itemProfilePages[0];
    return (_jsxs(_Fragment, { children: [_jsx(Tabs, { centered: false, tabList: tabItems, selectedTab: selectedTab, onTabSelected: setSelectedTab, displayType: config.tabs.displayType }), _jsx(ItemPickerGrid, { itemButtons: selectedItemProfilePage.buttons })] }));
});
ItemPickerTabs.displayName = 'ItemPickerTabs';
const getTabDataFromItemProfilePages = (pages, i18n) => {
    return pages.map(itemProfilePage => {
        return {
            label: i18n.translatable(itemProfilePage.title),
            value: itemProfilePage.number
        };
    });
};
